import React from 'react';
import { DropDown } from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import { DefaultPropertyType } from '../../../../interface';
import Styles from './index.module.scss';

export type DispatchPropsType = {
	onLoad: () => void;
};

export type MapStatePropsType = {
	items: Array<DefaultPropertyType>;
};

export type OwnPropsType = Omit<React.ComponentProps<typeof DropDown>, 'items'> & {
	icon?: React.ReactNode;
	label?: string;
	defaultProps?: any;
	selectedValue?: string;
};

type PropsType = OwnPropsType & MapStatePropsType & DispatchPropsType;

const DictionarySelectField: React.FC<PropsType> = ({
	onLoad,
	label,
	defaultProps,
	items,
	selectedValue,
	icon,
	...props
}) => {
	const { t } = useTranslation();

	React.useEffect(() => {
		if (!items.length) {
			onLoad();
		}
	}, []);
	
	const getOptions = (items: any) => {
		if (items[0]) {
			return [...defaultProps, ...items[0]]
		}
		return defaultProps;
	}

	const getLabel = () => {

		if (selectedValue !== undefined) {
			const finalItemList = getOptions(items)
			return finalItemList.find(({ value }: any) => value === selectedValue)
				?.label;
		}
		return label;
	};

	return (

		<DropDown
			{...props}
			trigger={'click'}
			items={getOptions(items)}
		>
			<div className={Styles.dropDownTrigger}>
				{getLabel()}
				{icon}
			</div>
		</DropDown>
	);
};

export default DictionarySelectField;
